<template>
  <div v-if="system">
  <v-tabs
    v-model="tab"
    background-color="deep-purple accent-4"
    dark
    height="70px"
    grow
    icons-and-text
  >

    <v-tab href="#tab-1">
      Inst.
      <v-icon>mdi-cog</v-icon>
    </v-tab>

    <v-tab href="#tab-2">
      Reducerings<br/>
      Regler
      <v-icon>mdi-tune</v-icon>
    </v-tab>

    <v-tab href="#tab-3">
      Spela
      <v-icon>mdi-play</v-icon>
    </v-tab>
  </v-tabs>

  <v-tabs-items v-model="tab">
    <v-tab-item
      value="tab-1"
    >
      <v-col class="d-flex" cols="12" sm="12">
        <v-select
          :items="sortings"
          label="Sortering"
          dense outlined
          v-model="sorting"
          persistent-hint
          @change="changeSorting"
          :hint="sorting == 'own_rank' ? 'Du kan nu sätta egen rangorning på hästar genom att dra och släppa dem!' : ''"
        >
        </v-select>
      </v-col>
      <v-list
        dense
        nav
      >
        <v-list-item
          link
          @click="navigateToSystems"
        >
          <v-list-item-icon>
            <v-icon>mdi-arrow-left-circle</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Lämna systemet</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-subheader>Kuponginställningar</v-subheader>
      <v-divider></v-divider>

      <v-card>
        <v-col class="d-flex" cols="12" sm="12">
          <v-text-field
            :readonly="isLocked"
            label="Antal system"
            :hint="'Systemet kommer spelas i sin helhet ' + system.coupon_settings.bet_multiplier + ' gång/er, vilket påverkar kostnaden för spelet.'"
            dense
            outlined
            v-model="system.coupon_settings.bet_multiplier"
            persistent-hint
            @change="updateCouponSettings"
          >
          </v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
          <v-text-field
            :readonly="isLocked"
            label="Målvinst"
            :hint="system.coupon_settings.row_value_target < 1 ? 'Målvinst ej aktiverad' : 'Rader med förväntad utdelning under ' + system.coupon_settings.row_value_target + ' kommer att spelas fler gånger för att säkra en minsta utdelning, vilket påverkar kostnaden för spelet.'"
            dense outlined
            v-model="system.coupon_settings.row_value_target"
            persistent-hint
            @change="updateCouponSettings"
          >
          </v-text-field>
        </v-col>
        <div v-if="isV6Eligible">
          <v-col class="d-flex" cols="12" sm="12">
            <v-checkbox v-model="system.coupon_settings.v6" label="V6" @change="updateCouponSettings" :readonly="isLocked"></v-checkbox>
          </v-col>
          <v-col class="d-flex" cols="12" sm="12">
            <v-text-field :disabled="system.coupon_settings.v6" :readonly="isLocked" label="V6 upp till radvärde" dense outlined v-model="system.coupon_settings.v6_limit_row_value" hide-details="false" @change="updateCouponSettings"></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="12">
            <v-text-field :disabled="system.coupon_settings.v6" :readonly="isLocked" label="V6 upp given egen rank" dense outlined v-model="system.coupon_settings.v6_limit_own_rank_sum" hide-details="false" @change="updateCouponSettings"></v-text-field>
          </v-col>
        </div>

        <v-col class="d-flex" cols="12" sm="12" style="padding-bottom:0px">
          <v-select
            :items="reserveOptions"
            label="Reservhantering"
            :readonly="isLocked"
            dense
            outlined
            hide-details
            v-model="reserveOption.base"
            @change="changeReserveOption"
            style="margin-bottom:0px"></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12" style="padding-top:0px">
          <v-checkbox
            dense
            v-model="reserveOption.selectedHorses"
            class="d-flex-sm-12"
            :readonly="isLocked"
            label="Inkludera valda hästar som reserver"
            @change="changeReserveOption"
            :hint="reserveOption.selectedHorses === true ? 'Valda hästar kommer finnas med i urvalet av reserver' : 'Valda hästar kommer EJ finnas med i urvalet av reserver'"
            persistent-hint
          ></v-checkbox>
        </v-col>

      </v-card>

    </v-tab-item>
    <v-tab-item
      value="tab-2"
    >
      <ReductionRule label="Poäng" :rule="system.reduction_rules.points" type="slider" :system="system" min="0" max="50"/>
      <ReductionRule label="Egen rank" :rule="system.reduction_rules.own_rank" type="slider" :system="system" min="0" max="50"/>
      <ReductionRule label="Startnummer" :rule="system.reduction_rules.startnumber_sum" type="slider" :system="system" min="0" max="50"/>
      <ReductionRule label="RadVärde" :rule="system.reduction_rules.row_value" type="fields" :system="system"/>
      <ReductionRule label="ABCD" :rule="system.reduction_rules.abcd_rule" type="composite" :system="system">
        <ReductionRule v-for="(rule, index) in [system.reduction_rules.abcd_a, system.reduction_rules.abcd_b, system.reduction_rules.abcd_c, system.reduction_rules.abcd_d]" :key="index" min="0" :max="numberOfRaces" :rule="rule" type="partial" :system="system" :label="rule.prio"/>
      </ReductionRule>
      <ReductionRule v-for="(rule, index) in system.reduction_rules.groups" :key="`groupRule-${index}`" :label="`Utgång ${rule.group}`" min="0" :max="numberOfRaces" :rule="rule" type="group" :system="system"></ReductionRule>
      <v-btn v-if="system.reduction_rules.groups.length < 10" text color="primary" outlined style="margin-top:5px" @click="addGroupRule">
        <v-icon>mdi-plus</v-icon>Lägg till utgångsregel
      </v-btn>

    </v-tab-item>
    <v-tab-item
      value="tab-3"
    >
      <v-list
        dense
        nav
      >
        <v-list-item
          link
          @click="toggleSystemLock"
        >
          <v-list-item-icon>
            <v-icon v-if="system.locked" >mdi-lock-open</v-icon>
            <v-icon v-if="!system.locked">mdi-lock</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-if="!system.locked">Lås systemet</v-list-item-title>
            <v-list-item-title v-if="system.locked">Lås upp systemet</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          :href="couponFileURL()"
          :disabled="!isLocked"
        >
          <v-list-item-icon>
            <v-icon>mdi-file-download-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Ladda ned kupongfil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          @click="submitFileToATG()"
          :disabled="!isLocked"
        >
          <v-list-item-icon>
            <v-icon>mdi-upload-network-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Ladda upp system till ATG</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-tab-item>
  </v-tabs-items>

  <form ref="uploadForm" target="_blank" action="https://www.atg.se/services/v1/user/bets/upload/transferFileBet" enctype="multipart/form-data" method="POST">
    <input type="hidden" id="couponXml" :value="couponXml" name="fileBetXml">
  </form>
</div>

</template>
<style scoped>
</style>
<script>
import { mapActions } from 'vuex'
import ReductionRule from '@/components/ReductionRule.vue'
import ApiHelper from '@/services/ApiHelper'

export default {
  props: ['system'],
  data () {
    return {
      tab: null,
      couponXml: '',
      sorting: localStorage.getItem('sorting') || 'start_nr',
      sortings: [
        {
          text: 'Startnummer',
          value: 'start_nr'
        },
        {
          text: 'Spelprocent',
          value: 'stake_distribution_share'
        },
        {
          text: 'Vinnarodds',
          value: 'odds'
        },
        {
          text: 'Egen ranking',
          value: 'own_rank',
          hint: 'Dra och släpp hästar för att rangordna'
        },
        {
          text: 'Valda hästar',
          value: 'selected'
        }
      ],
      reserveOptions: [
        { value: 'SS', text: 'Insatsfördelning' },
        { value: 'VO', text: 'Vinnarodds' },
        { value: 'OR', text: 'Egen rankning' }
      ],
      reserveOption:
      {
        base: null,
        selectedHorses: null
      }
    }
  },
  components: {
    ReductionRule
  },

  mounted () {
    // Set reserveOption
    const reserveHandling = this.system.reserv_handling
    this.reserveOption.base = reserveHandling.substring(0, 2)
    this.reserveOption.selectedHorses = reserveHandling.substring(2) === 'S'
  },

  methods: {
    ...mapActions(['setRuleValuesAction', 'lockSystemAction', 'unlockSystemAction', 'fetchReductionResultAction', 'updateCouponSettingsAction', 'updateReserveHandlingAction']),

    navigateToSystems () {
      this.$router.push({ name: 'systems' })
    },

    changeSorting () {
      localStorage.setItem('sorting', this.sorting)
      this.$emit('changeSorting', this.sorting)
    },

    changeReserveOption () {
      let newReserveHandling = this.reserveOption.base
      if (this.reserveOption.selectedHorses) {
        newReserveHandling += 'S'
      }
      const details = { id: this.system.id, code: newReserveHandling }
      this.updateReserveHandlingAction(details)
    },

    updateCouponSettings () {
      const couponSettings = this.system.coupon_settings
      couponSettings.id = this.system.id
      this.updateCouponSettingsAction(couponSettings)
    },

    addGroupRule () {
      const groupRules = this.system.reduction_rules.groups
      const groupNames = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
      for (const x of groupNames) {
        const group = groupRules.find(y => y.group === x)
        if (!group) {
          const newGroup = { group: x, rule: 'group', min: 0, max: 0, use: true, id: this.system.id }
          this.setRuleValuesAction(newGroup)
          break
        }
      }
    },

    toggleSystemLock () {
      // const that = this
      if (!this.system.locked) {
        this.lockSystemAction(this.system.id).then(function () {
          location.reload()
          // this.$router.push({ path: `/systems/${that.system.id}` })
        })
      } else {
        this.unlockSystemAction(this.system.id)
      }
    },

    couponFileURL () {
      return process.env.VUE_APP_RAILS_API_URL + '/api/systems/' + this.system.id + '/coupon_file.xml'
    },

    submitFileToATG () {
      const that = this
      that.couponXml = ''

      return new Promise((resolve, reject) => {
        ApiHelper.fetchCouponFile(that.system.id)
          .then(response => {
            const xml = response
            that.couponXml = xml
            that.$nextTick(() => {
              that.$refs.uploadForm.submit()
              that.couponXml = ''
            })
          })
          .catch(error => {
            that.couponXml = ''
            reject(error)
          })
      })
    }
  },

  computed: {
    isLocked () {
      return this.system.locked
    },

    isV6Eligible () {
      return ['V64', 'V65'].includes(this.system.code)
    },

    numberOfRaces () {
      return this.system.game.race_list.length
    }

  }
}
</script>
